import { Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { css } from '@emotion/react'
import React from 'react'

import FormContentBlock from '../FormContentBlock'
import { FormContext, type FormInputType } from '../types'

const FormInputRadio: React.FC<{
  input: FormInputType & { type: 'radio' }
}> = ({ input }) => {
  const { name: inputName } = input
  const { submitting, direction, onChange } = React.useContext(FormContext)
  const [value, setValue] = React.useState(input.initialValue ?? null)
  const handleChange = React.useCallback(
    (newValue: string) => {
      onChange(inputName, newValue)
      setValue(newValue)
    },
    [inputName, onChange]
  )
  const directionToUse = input.direction ?? direction

  return (
    <RadioGroup value={value ?? input.initialValue ?? undefined} onChange={handleChange}>
      <Stack
        direction={directionToUse === 'horizontal' ? 'row' : 'column'}
        // flex: 1 ensures that the radio buttons take up the full width of the container
        css={css`
          .chakra-radio__label {
            flex: 1;
          }
        `}
        spacing={directionToUse === 'horizontal' ? '16px' : '4px'}
      >
        {input.options.map(item => (
          <Radio
            key={item.value}
            size="md"
            value={item.value}
            isDisabled={submitting || input.disabled}
            pointerEvents={submitting || input.disabled === true ? 'none' : 'auto'}
            spacing="12px"
            name={input.name}
          >
            <FormContentBlock content={item.label} />
          </Radio>
        ))}
      </Stack>
    </RadioGroup>
  )
}

export default FormInputRadio
